"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_lazyload_1 = require("react-lazyload");
var Header_1 = require("../Header");
var Nav_1 = require("../Nav");
var CarouselBanner_1 = require("../CarouselBanner");
var Products_1 = require("../Products");
var MagicBanner_1 = require("../MagicBanner");
var CountDownBanner_1 = require("../CountDownBanner");
var RichText_1 = require("../RichText");
var StickBottomTab_1 = require("../StickBottomTab");
var CardBanner_1 = require("../CardBanner");
var Cube_1 = require("../Cube");
var Coupon_1 = require("../Coupon");
var module_1 = require("../../stores/module");
var admin_1 = require("services/page/admin");
var common_1 = require("services/page/common");
var module_2 = require("../../../../utils/playground/module");
var ModuleStoreObj = new module_1.ModuleStore();
var Module = (function (_super) {
    __extends(Module, _super);
    function Module(props) {
        var _this = _super.call(this, props) || this;
        _this.getModuleComp = function () {
            var type = _this.props.simpleModule.type;
            var index = _this.props.index;
            var positionIndex = index + 1;
            var moduleDetail = _this.state.moduleDetail;
            var interaction = moduleDetail && moduleDetail.layout && moduleDetail.layout.interaction;
            switch (type) {
                case admin_1.TModuleType.TPageTitleLineType:
                    return Header_1.default;
                case admin_1.TModuleType.TQuickNav:
                    var NavBarWithPrm = Nav_1.default({ positionIndex: positionIndex });
                    return NavBarWithPrm;
                case admin_1.TModuleType.TSwiper:
                    if (interaction === common_1.ModuleInteraction.RollOver ||
                        interaction === common_1.ModuleInteraction.SingleSliding) {
                        return CardBanner_1.default({ positionIndex: positionIndex });
                    }
                    else if (interaction === common_1.ModuleInteraction.Zoom ||
                        interaction === common_1.ModuleInteraction.ZoomSliding) {
                        var TCubeWithPrm = Cube_1.default({ positionIndex: positionIndex });
                        return TCubeWithPrm;
                    }
                    else {
                        var TSwiperWithPrm = CarouselBanner_1.default({ positionIndex: positionIndex });
                        return TSwiperWithPrm;
                    }
                case admin_1.TModuleType.TMagicBannerType:
                case admin_1.TModuleType.TMagicBannerTwo:
                    var MagicTwoBannerWithPrm = MagicBanner_1.default({ positionIndex: positionIndex });
                    return MagicTwoBannerWithPrm;
                case admin_1.TModuleType.TMultiProductModuleType:
                    var productsWithPrm = Products_1.default({ positionIndex: positionIndex });
                    return productsWithPrm;
                case admin_1.TModuleType.TCountdownBanner:
                    return CountDownBanner_1.default;
                case admin_1.TModuleType.TRichText:
                    return RichText_1.default;
                case admin_1.TModuleType.TStickBotomTab:
                    console.log("render stick");
                    var StickBottomTabWithPrm = StickBottomTab_1.default({ positionIndex: positionIndex });
                    return StickBottomTabWithPrm;
                case admin_1.TModuleType.TCoupon:
                    var CouponWithPrm = Coupon_1.default({ positionIndex: positionIndex });
                    return CouponWithPrm;
                default:
                    return null;
            }
        };
        _this.state = {
            moduleDetail: null
        };
        return _this;
    }
    Module.prototype.componentDidMount = function () {
        var _this = this;
        var simpleModule = this.props.simpleModule;
        ModuleStoreObj.loadModuleDetailQueue(simpleModule.id).then(function (moduleDetail) {
            _this.setState({ moduleDetail: moduleDetail });
        });
    };
    Module.prototype.render = function () {
        var moduleDetail = this.state.moduleDetail;
        var _a = this.props, index = _a.index, navFixed = _a.navFixed, setTopMap = _a.setTopMap, topMap = _a.topMap, hasTitle = _a.hasTitle, moduleMap = _a.moduleMap, addModuleMap = _a.addModuleMap, overAllBgc = _a.overAllBgc;
        var Comp = this.getModuleComp();
        var commonProps = {
            id: (moduleDetail && moduleDetail.header.position) || "floor" + (index + 1)
        };
        return moduleDetail ? (React.createElement("div", { id: commonProps.id, ref: function (node) {
                if (node) {
                    setTopMap && setTopMap(index, node);
                    addModuleMap && addModuleMap(index, node, "#" + commonProps.id);
                }
            } }, +index < 1 && !module_2.isLazyMod(moduleDetail.type) ? (React.createElement(Comp, { moduleDetail: moduleDetail, index: index + 1, navFixed: navFixed, setTopMap: setTopMap, topMap: topMap, hasTitle: hasTitle, moduleMap: moduleMap, addModuleMap: addModuleMap, commonProps: commonProps, overAllBgc: overAllBgc, proModules: moduleDetail.module.proModules })) : (React.createElement(react_lazyload_1.default, { offset: 100, height: window.innerHeight },
            React.createElement(Comp, { moduleDetail: moduleDetail, index: index + 1, navFixed: navFixed, setTopMap: setTopMap, topMap: topMap, hasTitle: hasTitle, moduleMap: moduleMap, addModuleMap: addModuleMap, commonProps: commonProps, overAllBgc: overAllBgc, proModules: moduleDetail.module.proModules }))))) : null;
    };
    return Module;
}(React.Component));
exports.default = Module;
